import { render } from "./PatientModal.vue?vue&type=template&id=221a7f08"
import script from "./PatientModal.vue?vue&type=script&lang=js"
export * from "./PatientModal.vue?vue&type=script&lang=js"

import "./PatientModal.vue?vue&type=style&index=0&id=221a7f08&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__